


























































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  inheritAttrs: false
})
export default class ListItem extends Vue {
  @Prop({ type: String, default: 'div' })
  readonly container!: string

  @Prop({ type: [Boolean, String], default: false })
  readonly divider!: boolean | 'full' | 'inset'

  @Prop({ type: Boolean, default: false })
  readonly lastDivider!: boolean

  dividerClasses = 'border-b border-gray-400'

  get hasDivider () {
    return this.divider !== false
  }

  get isDividerInset () {
    return this.divider === 'inset'
  }

  checkEndSlot () {
    return this.$slots.end !== undefined
  }

  checkStartSlot () {
    return this.$slots.start !== undefined
  }

  checkDetailsSlot () {
    return this.$slots.details !== undefined
  }
}
